import React from 'react'

import Footer from 'components/Footer'

import { Wrapper, Main, FooterWrapper } from './IndexLayout.styles'

import { IndexLayoutHeader, IndexLayoutHeaderProps } from './IndexLayoutHeader'
import Sidebar, { Variant } from './Sidebar'

interface IndexLayoutProps extends IndexLayoutHeaderProps {
  className?: string
  variant?: Variant
  isCreatingWorkspace?: boolean
  fullWidth?: boolean
  maxContainerWidth?: string
  isOnboardingLicensesSignupEnabled?: boolean
}

const IndexLayout: React.FC<IndexLayoutProps> = ({
  className,
  children,
  headerLink,
  blockLogoLink,
  variant,
  isCreatingWorkspace,
  fullWidth,
  maxContainerWidth,
  isOnboardingLicensesSignupEnabled,
}) => {
  return (
    <Wrapper className={className}>
      <IndexLayoutHeader
        headerLink={headerLink}
        blockLogoLink={blockLogoLink}
      />
      {variant && <Sidebar variant={variant} />}
      <Main
        isCreatingWorkspace={isCreatingWorkspace}
        fullWidth={fullWidth}
        maxContainerWidth={maxContainerWidth}
        isOnboardingLicensesSignupEnabled={isOnboardingLicensesSignupEnabled}>
        {children}
      </Main>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Wrapper>
  )
}

export default IndexLayout
